
export async function createForeignFiscalData(foreignFiscalDataRepository, foreignFiscalData) {
  return foreignFiscalDataRepository.save(foreignFiscalData)
}

